var _effectorFileName = "/builds/gmini/front-ui-kit/src/Chip/Chip.tsx";
import { Container, DeleteIcon, Label, LoadingIcon } from './Chip.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Chip = ({
  label,
  loading,
  onDelete,
  dataTestIdFor
}) => /*#__PURE__*/_jsxs(Container, {
  "data-test-id": dataTestIdFor === null || dataTestIdFor === void 0 ? void 0 : dataTestIdFor.root,
  children: [/*#__PURE__*/_jsx(Label, {
    children: label
  }), loading ? /*#__PURE__*/_jsx(LoadingIcon, {
    size: 16,
    "data-test-id": dataTestIdFor === null || dataTestIdFor === void 0 ? void 0 : dataTestIdFor.loadingIcon
  }) : /*#__PURE__*/_jsx(DeleteIcon, {
    onClick: onDelete,
    "data-test-id": dataTestIdFor === null || dataTestIdFor === void 0 ? void 0 : dataTestIdFor.deleteIcon
  })]
});